module.exports = __webpack_public_path__ + "static/media/bank.6128e9fc.jpg";